import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("Render error", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="card p-6 max-w-md text-center space-y-3">
          <h2 className="font-serif text-xl font-semibold">Something went wrong on this screen</h2>
          <p className="text-sm text-[#6B7280]">Your data is safe. Reload the page, or go back to the dashboard.</p>
          <div className="flex gap-2 justify-center">
            <button type="button" data-testid="error-reload" onClick={() => window.location.reload()} className="h-10 px-4 rounded-full bg-[#C86D82] text-white text-sm font-medium">Reload</button>
            <button type="button" data-testid="error-home" onClick={() => { window.location.href = "/"; }} className="h-10 px-4 rounded-full border text-sm font-medium">Dashboard</button>
          </div>
        </div>
      </div>
    );
  }
}
